<script lang="ts">
    import CopilotImg from "$/images/copilot.svg"
    import { ActiveTopicStore } from "$/stores/extension/ActiveTopicStore";
    import { createEventDispatcher, onMount } from "svelte";
    import Suggestion, { type SuggestionItem } from "./Suggestion.svelte";

    const dispatch = createEventDispatcher();

    export let content: string;
    export let nameSuggestion: string;
    export let includeNameSuggestion:boolean = true;

    let aiSuggestions: any;
    let titleSuggestion = nameSuggestion;

    let suggestions: SuggestionItem[] = [];
    
    let containerElement: HTMLElement;
    
    export function focus() {
        containerElement.focus();
    }

    export function applySuggestion(index) {
        const suggestion = suggestions.find(s => s.index === index);

        if (suggestion) {

            // dispatch suggestion
            dispatch(suggestion.type, suggestion.value);

            // remove suggestion from suggestions
            const indexToRemove = suggestions.findIndex(s => s.index === index);
            if (indexToRemove !== -1) {
                suggestions.splice(indexToRemove, 1);
                suggestions = suggestions;
            }
        }
    }

    onMount(async () => {
        aiSuggestions = await ActiveTopicStore.getSnippetSuggestions(content);

        suggestions = [];

        if(includeNameSuggestion && titleSuggestion && titleSuggestion !== "") {
            suggestions.push({
                index: suggestions.length + 1,
                type: "changeTitle",
                value: nameSuggestion,
                items: [{ name: titleSuggestion }],
                text: "Set title to"
            });
        }

        if(aiSuggestions?.topic) {
            suggestions.push({
                index: suggestions.length + 1,
                type: "changeTopic",
                value: aiSuggestions.topic.id,
                items: [{ name: aiSuggestions.topic.name }],
                text: "Change topic to"
            });
        }

        if(aiSuggestions?.tags?.length > 0) {
            suggestions.push({
                index: suggestions.length + 1,
                type: "addTags",
                value: aiSuggestions.tags,
                items: aiSuggestions.tags.map(tag => ({ name: `#${tag.tag}` })),
                text: `Add tag${aiSuggestions.tags.length > 1 ? "s" : ""}`
            });
        }
    })
</script>

{#if suggestions.length > 0}
    <div class="suggestions-container" bind:this={containerElement}>
        <div class="suggestions-agent">
            <img src={CopilotImg} alt="Copilot Robot Profile Picture"/>
        </div>

        <div class="suggestions">
            {#each suggestions as suggestion (suggestion.index)}
                <Suggestion 
                    suggestionItem={suggestion}
                    on:apply={(data) => applySuggestion(data.detail.index)}
                />
            {/each}
        </div>
    </div>
{/if}

<style>
    .suggestions-container {
        @apply flex flex-row items-end gap-1 py-2 absolute top-0 left-0 right-0 z-30;
        transform: translateY(-100%);
    }

    .suggestions-agent {
        @apply bg-black border border-gray-200 flex items-center justify-center h-8 w-8 min-w-8 rounded-full;
    }
    
    .suggestions-agent img {
        @apply w-6 h-6 min-w-6;
    }

    .suggestions {
        @apply flex flex-col gap-1 flex-1;
    }

</style>